import {factory} from './localStorage'

export const REFRESH_TOKEN = factory('refreshToken')
